import { useEffect, useMemo, useRef } from "react";
import { usePrevious } from "../helpers";
import debounce from "lodash/debounce";
export var useDebouncedQuery = function (api, queryString, query) {
    if (query === void 0) { query = ''; }
    var apiRef = useRef(api);
    apiRef.current = api;
    var queryChanged = usePrevious(query).current !== query;
    var debouncedApi = useMemo(function () { return debounce(function (queryString) {
        return apiRef.current(queryString);
    }, 200, { trailing: true }); }, []);
    useEffect(function () {
        var resolvedApi = queryChanged ? debouncedApi : apiRef.current;
        if (resolvedApi === apiRef.current)
            debouncedApi.cancel();
        resolvedApi(queryString);
    }, [debouncedApi, queryString, query]);
    useEffect(function () {
        return debouncedApi.cancel;
    }, [debouncedApi]);
};
